import { Children, FC, Fragment, cloneElement, memo, useEffect, useMemo, useState } from "react";
import TruncateMarkup from "react-truncate-markup";
import parse from "html-react-parser";
import styled from "styled-components";

import useTextHeight from "../projectCard/hooks/useTextHeight";
import LineCounter from "shared/components/TruncateTextOverflow/LineCounter";
import { useTeamContext } from "shared/pages/exploreHseContextsNew/provider/TeamContext";

interface TruncateTextOverflowProps {
    children: React.ReactElement;
    overflowContainerRef: React.RefObject<HTMLDivElement>;
    measureMethod?: 'scrollHeight' | 'clientHeight';
    more?: string | React.ReactNode;
    less?: string | React.ReactNode;
    noTruncate?: boolean;
    expanded?: boolean;
    extraToggle?: React.ReactNode;
    lines?: number;
}

const MoreText = styled.span`
    color: ${({ theme }) => theme.link.default};
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    font-style: normal;
    transition: color 0.2s;
    cursor: pointer;

    &:hover {
        color: ${({ theme }) => theme.link.hover};
        transition: color 0.2s;
    }
`;

const TruncateTextOverflow: FC<TruncateTextOverflowProps> = ({
    children,
    overflowContainerRef,
    measureMethod = 'scrollHeight',
    noTruncate = false,
    lines,
    more,
    less,
    expanded,
    extraToggle,
}) => {
    const { getMeasures, annotationHeight } = useTextHeight(overflowContainerRef);
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    }

    useEffect(() => {
        if (isExpanded) {
            setIsExpanded(false);
        }
    }, [children]);

    const measureStyles = useMemo(() => {
        if (measureMethod === 'clientHeight') {
            return {
                position: 'absolute',
                visibility: 'hidden'
            }
        }
    }, [measureMethod]);

    const childForRender = useMemo(() => {
        const parts = Children.toArray(children.props.children).map((p, i) =>
            typeof p === "string" ? <Fragment key={`__html_${i}`}>{parse(p)}</Fragment> : p,
        );

        return cloneElement(children, undefined, ...parts);
    }, [children]);

    if (!annotationHeight) {
        return (
            <LineCounter callback={getMeasures}>
                {cloneElement(childForRender, {
                    style: measureStyles
                })}
            </LineCounter>
        )
    }

    if (isExpanded || noTruncate || expanded) {
        const expandedChild =
            less && (!noTruncate || expanded)
                ? cloneElement(
                    childForRender,
                    undefined,
                    ...Children.toArray(childForRender.props.children),
                    " ",
                    <MoreText key="__less__" onClick={toggleExpand}>
                        {less}
                    </MoreText>,
                )
                : childForRender;

        return (
            <div>
                {expandedChild}
            </div>
        )
    }

    return (
        <>
            <TruncateMarkup
                lines={lines || annotationHeight}
                ellipsis={more && <MoreText onClick={toggleExpand}>... {more}</MoreText>}
            >
                {childForRender}
            </TruncateMarkup>
        </>
    )
}

export default memo(TruncateTextOverflow);import { Children, FC, Fragment, cloneElement, memo, useEffect, useMemo, useState } from "react";
import TruncateMarkup from "react-truncate-markup";
import parse from "html-react-parser";
import styled from "styled-components";

import useTextHeight from "../projectCard/hooks/useTextHeight";
import LineCounter from "shared/components/TruncateTextOverflow/LineCounter";
import { useTeamContext } from "shared/pages/exploreHseContextsNew/provider/TeamContext";

interface TruncateTextOverflowProps {
    children: React.ReactElement;
    overflowContainerRef: React.RefObject<HTMLDivElement>;
    measureMethod?: 'scrollHeight' | 'clientHeight';
    more?: string | React.ReactNode;
    less?: string | React.ReactNode;
    noTruncate?: boolean;
    expanded?: boolean;
    extraToggle?: React.ReactNode;
    lines?: number;
}

const MoreText = styled.span`
    color: ${({ theme }) => theme.link.default};
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    font-style: normal;
    transition: color 0.2s;
    cursor: pointer;

    &:hover {
        color: ${({ theme }) => theme.link.hover};
        transition: color 0.2s;
    }
`;

const TruncateTextOverflow: FC<TruncateTextOverflowProps> = ({
    children,
    overflowContainerRef,
    measureMethod = 'scrollHeight',
    noTruncate = false,
    lines,
    more,
    less,
    expanded,
    extraToggle,
}) => {
    const { getMeasures, annotationHeight } = useTextHeight(overflowContainerRef);
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    }

    useEffect(() => {
        if (isExpanded) {
            setIsExpanded(false);
        }
    }, [children]);

    const measureStyles = useMemo(() => {
        if (measureMethod === 'clientHeight') {
            return {
                position: 'absolute',
                visibility: 'hidden'
            }
        }
    }, [measureMethod]);

    const childForRender = useMemo(() => {
        const parts = Children.toArray(children.props.children).map((p, i) =>
            typeof p === "string" ? <Fragment key={`__html_${i}`}>{parse(p)}</Fragment> : p,
        );

        return cloneElement(children, undefined, ...parts);
    }, [children]);

    if (!annotationHeight) {
        return (
            <LineCounter callback={getMeasures}>
                {cloneElement(childForRender, {
                    style: measureStyles
                })}
            </LineCounter>
        )
    }

    if (isExpanded || noTruncate || expanded) {
        const expandedChild =
            less && (!noTruncate || expanded)
                ? cloneElement(
                    childForRender,
                    undefined,
                    ...Children.toArray(childForRender.props.children),
                    " ",
                    <MoreText key="__less__" onClick={toggleExpand}>
                        {less}
                    </MoreText>,
                )
                : childForRender;

        return (
            <div>
                {expandedChild}
            </div>
        )
    }

    return (
        <>
            <TruncateMarkup
                lines={lines || annotationHeight}
                ellipsis={more && <MoreText onClick={toggleExpand}>... {more}</MoreText>}
            >
                {childForRender}
            </TruncateMarkup>
        </>
    )
}

export default memo(TruncateTextOverflow);